import React from 'react'
import { StyleRightContentWrapper, StyleWhoWeAreWrapper } from './style'
import { StyleImageWrapper } from '@pages/front/commons/ImageWrapper/style'
import { StyleText } from '@pages/front/commons/Text/style'
import { StyleImage } from '@pages/front/Layout/Footer/style'
import doctor from './doctor.png'
const WhoWeAre = () => {
  return (
    <StyleWhoWeAreWrapper>
      <StyleRightContentWrapper>
        <StyleText color="#262f77" weight="600" fontSize="22" fontSizeSm="1">
          Who Are We?
        </StyleText>
        <StyleText fontSize="16" align="justify" textWidth="700" justified>
          Supchar is a comprehensive, app-based healthcare platform located in
          Kathmandu, Nepal, designed to simplify and improve access to medical
          services for everyone. Through the Supchar app, users can conveniently
          book and schedule both video call consultations and in-clinic
          appointments with licensed doctors and healthcare professionals.
          Whether you're managing chronic conditions or seeking expert advice on
          new symptoms, Supchar ensures that quality care is just a few taps
          away.
          <br />
          <br />
          In addition to medical appointments, Supchar also allows users to
          order prescribed medicines and a variety of healthcare services
          directly from the app. Our goal is to bring essential health services
          to your doorstep, saving time and ensuring timely treatment. Whether
          you need lab tests, at-home health checkups, or prescription refills,
          Supchar is your trusted partner for seamless healthcare delivery in
          the Kathmandu Valley.
          <br />
          <br />
        </StyleText>
      </StyleRightContentWrapper>
      <StyleImageWrapper widthsm="200" direction="center">
        <StyleImage src={doctor} />
      </StyleImageWrapper>
    </StyleWhoWeAreWrapper>
  )
}

export default WhoWeAre
